import api from '../api';

import { ParamsBodyFinancialPending, ParamsDataFinancialPending } from 'utils/typeServices';

type ParamsResponse = {
    Data: {
        Cobrancas: Array<ParamsDataFinancialPending>;
        TermoIturanHub?: {
            NrTipoModeloContrato: number;
            CdModeloContrato: number;
            TermoIturanHubBase64: string;
        };
    };
}

export const PostFinancialPending = async ({ token, body }: { token: string | null, body: ParamsBodyFinancialPending }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Pagamento/ListarPendenciasFinanceirasCliente', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error: any) {
        return { data: null, error_msg: error?.response?.data?.Data || '' };
    }
}
